import { Store } from 'store';
import getPrice from 'store/price/selector/getPrice';
import { PricesToFetch } from 'store/price/types';

const removeExistingPrices = (store: Store, prices: PricesToFetch) => {
  const result: PricesToFetch = {};
  Object.keys(prices).forEach((categoryId) => {
    const missingPriceForProductIds = prices[categoryId].productIds.filter(
      (pId) => !getPrice(store, Number(categoryId), pId, 1),
    );
    if (!missingPriceForProductIds.length) return;
    result[categoryId] = {
      categoryId: Number(categoryId),
      productIds: missingPriceForProductIds,
    };
  });
  return result;
};

export default removeExistingPrices;
